import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const StrategicIntelligenceForm = ({ formData, onUpdate }) => {
  const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
  ];

  return (
    <div className="space-y-6">
      <Input
        label="Biggest Revenue Bottleneck"
        type="text"
        placeholder="Describe your main revenue challenge"
        value={formData?.revenueBottleneck || ''}
        onChange={(e) => onUpdate({ revenueBottleneck: e?.target?.value })}
        required
      />

      <Input
        label="What Stops You from Doubling Revenue?"
        type="text"
        placeholder="Describe the main obstacles"
        value={formData?.doublingRevenue || ''}
        onChange={(e) => onUpdate({ doublingRevenue: e?.target?.value })}
        required
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Select
          label="Do You Track CAC (Customer Acquisition Cost)?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.trackCAC || ''}
          onChange={(value) => onUpdate({ trackCAC: value })}
          required
        />

        <Select
          label="Do You Track LTV (Lifetime Value)?"
          placeholder="Select option"
          options={yesNoOptions}
          value={formData?.trackLTV || ''}
          onChange={(value) => onUpdate({ trackLTV: value })}
          required
        />
      </div>

      <Select
        label="Are You Dependent on One Major Client?"
        placeholder="Select option"
        options={yesNoOptions}
        value={formData?.majorClientDependency || ''}
        onChange={(value) => onUpdate({ majorClientDependency: value })}
        required
      />
    </div>
  );
};

export default StrategicIntelligenceForm;